import { ASSIGN_TEMPLATE_FROM_GROUP_SUCCESS } from 'modules/groups/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

import * as types from '../actionTypes';
import type { FetchGroupCustomTemplateSuccessAction, FetchTemplatesFOByDealerSuccessAction } from '../types/actions';
import type { Template } from '../types/entities';

const adapter = createEntityAdapter<Template>({ selectId: ({ id }) => id });

export const initialState = adapter.getInitialState();

type State = typeof initialState;

const handleFetchTemplatesFoByDealer = (state: State, action: FetchTemplatesFOByDealerSuccessAction) =>
  adapter.updateMany(state, action.payload!.content);

const handleFetchGroupCustomTemplate = (state: State, action: FetchGroupCustomTemplateSuccessAction) =>
  adapter.updateMany(state, action.payload!.content);

export default createReducer(initialState, {
  [types.FETCH_TEMPLATES_FO_BY_DEALER_SUCCESS]: handleFetchTemplatesFoByDealer,
  [types.FETCH_GROUP_CUSTOM_TEMPLATE_SUCCESS]: handleFetchGroupCustomTemplate,
  [types.DELETE_TEMPLATE_SUCCESS]: adapter.removeOne,
  [ASSIGN_TEMPLATE_FROM_GROUP_SUCCESS]: adapter.updateOne,
});
